import Model from "./base/model";

class oficioFile extends Model{
  resourceName() {
    return "oficio_files";
  }

  fields() {
    return {
      oficio_path: "",
      oficio_name: "",
      number: "",
      serie: "",
      value: "",
      weight: "",
      volume: "",
      volume_type: "",
      canhoto:"",
      created_at: "",
    }
  }
}

export default new oficioFile();
